import generateReceitaPDF from './generateReceitaPDF';
import generateReceitaControladaPDF from './generateReceitaControladaPDF';
import { resolveEmitenteMedico } from './receitaEmitente';

export const isReceitaControlada = receita => receita?.tipo === 'Controlada';

export default async function gerarPdfReceita({
  receita,
  tipoImpressao,
  qrcodeBase64,
  assinaturaDigital,
  assinaturaEletronica,
  isDoctorLoggedIn,
}) {
  if (isReceitaControlada(receita)) {
    const emitente = await resolveEmitenteMedico({ receita });

    return generateReceitaControladaPDF({
      receita,
      tipo: tipoImpressao,
      qrcodeBase64,
      assinaturaDigital,
      assinaturaEletronica,
      isDoctorLoggedIn,
      emitente,
    });
  }

  return generateReceitaPDF({
    receita,
    tipo: tipoImpressao,
    qrcodeBase64,
    assinaturaDigital,
    assinaturaEletronica,
    isDoctorLoggedIn,
  });
}
